import axios from 'axios';
import { Constants } from 'utils';

/**
 * responsible for creating the instance of axios to connect to Github API
 */

export const github = () => axios.create({
  baseURL: Constants.GITHUB.BASE_URL,
});